import { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { toast } from 'sonner';
import { invInput, errMsg } from './invApi';

const SupplierCard = ({ s, api, reload }) => {
  const [f, setF] = useState(s);
  const save = async (patch) => {
    const next = { ...f, ...patch };
    setF(next);
    try { await api.patch(`/suppliers/${s.id}`, { phone: next.phone, website: next.website, email: next.email, account_number: next.account_number, has_account: next.has_account, rating: next.rating, notes: next.notes }); }
    catch (e) { toast.error(errMsg(e)); reload(); }
  };
  const field = (k, ph) => <input className={invInput} placeholder={ph} value={f[k] || ''} onChange={e => setF({ ...f, [k]: e.target.value })} onBlur={() => save({})} data-testid={`supplier-${k}-${s.id}`} />;
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 space-y-3" data-testid={`supplier-${s.id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-white font-medium flex-1">{s.name}</p>
        <span className="text-xs text-slate-400">{s.purchases} achat(s) · délai {s.avg_lead_days != null ? `${s.avg_lead_days} j` : 'inconnu'}</span>
        <div className="flex">{[1, 2, 3, 4, 5].map(n => <button key={n} onClick={() => save({ rating: n })} data-testid={`supplier-rate-${s.id}-${n}`}><Star size={14} className={n <= (f.rating || 0) ? 'text-amber-400 fill-amber-400' : 'text-slate-600'} /></button>)}</div>
        <label className="flex items-center gap-1.5 text-xs text-slate-300"><input type="checkbox" className="accent-amber-500" checked={!!f.has_account} onChange={e => save({ has_account: e.target.checked })} data-testid={`supplier-account-${s.id}`} /> Compte ouvert</label>
      </div>
      <div className="grid sm:grid-cols-4 gap-2">{field('phone', 'Téléphone')}{field('website', 'Site web (https://…)')}{field('email', 'Courriel')}{field('account_number', 'No de compte')}</div>
    </div>
  );
};

export const SuppliersTab = ({ api }) => {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState('');
  const load = () => api.get('/suppliers').then(setRows);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const add = async () => { try { await api.post('/suppliers', { name }); setName(''); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-3" data-testid="inventory-suppliers-tab">
      <p className="text-xs text-slate-500">Les fournisseurs se créent seuls à chaque facture reçue. Complétez-les au besoin.</p>
      <div className="flex gap-2">
        <input className={invInput} placeholder="Ajouter un fournisseur" value={name} onChange={e => setName(e.target.value)} data-testid="supplier-new-name" />
        <button onClick={add} disabled={!name.trim()} className="px-4 rounded-lg bg-amber-500 text-black text-sm font-semibold disabled:opacity-40" data-testid="supplier-new-save">Ajouter</button>
      </div>
      {rows.map(s => <SupplierCard key={s.id} s={s} api={api} reload={load} />)}
    </div>
  );
};
